import { useEffect, useMemo, useState } from "react";
import { PlusCircle } from "lucide-react";
import { ServiceData } from "../../Services/Service";
import ModalBordereauFormAdmin from "../../View/ModalBordereauFormAdmin";
import { Listes } from "../../Types/Listes";
import BordereauCard from "../../View/BordereauCard";
import { grouperParPeriode } from "../../View/GroupeParPeriode";
import { validateBordereauForm } from "../../View/validateBordereauForm";
import { toast } from "react-toastify";
import { handleAddNumBl, handleNumBlChange, handleRemoveNumBl, onDelete } from "../../Services/DataAction";
import useAutoAlerteSonore from "../../Services/Alert";

const Home = () => {
  const [bordereaux, setBordereaux] = useState<Listes[]>([]);
  const [filteredBordereaux, setFilteredBordereaux] = useState<Listes[]>([]);
  const [form, setForm] = useState({
    destinataire: '',
    nombres: null,
    nombrepack: null,
    bon: '',
    NumBl:[''],
    livreur: '',
    vehicule: '',
    chaffeur: '',
    telephone: '',
    cooperative: '',
    datelivraison: ''
  });

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState<Listes | null>(null);
  const [showVerifiedOnly, setShowVerifiedOnly] = useState(false);
  const [showSentOnly, setShowSentOnly] = useState(false);
  const [search, setSearch] = useState('');
  const isAdminOrMagasinLoin = true;
  const [isModifier,setIsModifier]=useState<boolean>(false);


  const fetchLBordereau = async () => {
    try {
      const response = await ServiceData("/api/admin/listbordereau", "GET");
      if (Array.isArray(response)) {
        setBordereaux(response);
        setFilteredBordereaux(response);
      }
    } catch (err: any) {
      setError("Erreur lors du chargement des bordereaux");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLBordereau();
  }, []);

  const validateForm = () => validateBordereauForm(form, isEditMode ? "edit" : "create",isAdminOrMagasinLoin, setError);

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
    setError(null);
  };

  const openCreatePiece = () => {
    setIsModalOpen(true);
    setIsEditMode(false);
    setForm({
      destinataire: '',
      nombres: null,
      nombrepack: null,
      bon: '',
      NumBl:[''],
      livreur: '',
      vehicule: '',
      chaffeur: '',
      telephone: '',
      cooperative: '',
      datelivraison: ''
    });
    setError(null);
  };

  const handleInputChange = (key: string, value: string) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = { ...form };

    try {
      if (isEditMode && selectedUser) {
        await ServiceData(`/api/admin/editbordereau/${selectedUser.id}`, 'PUT', payload);
        setBordereaux(prev =>
          prev.map(b => (b.id === selectedUser.id ? { ...b, ...payload } : b))
        );
      } else if (isModifier && selectedUser) {
        await ServiceData(`/api/admin/modifierbordereau/${selectedUser.id}`, 'PUT', payload);
        setBordereaux(prev => prev.map(b => (b.id === selectedUser.id ? { ...b, ...payload } : b)));
      } else {
        const newItem = await ServiceData("/api/admin/createbordereau", 'POST', payload);
        setBordereaux(prev => [...prev, newItem]);
      }
      toast.success("Bordereau enregistré avec succès.");
      closeModal();
      fetchLBordereau();
    } catch (err: any) {
      toast.error(err.message || "Erreur serveur.");
    }
  };

  const searchData = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
    const filter = bordereaux.filter(item =>
      `${item.Destinataire} ${item.Expediteur} ${item.Chaffeur} ${item.Livreur}  ${item.NumberBordereau}`
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setFilteredBordereaux(filter);
  };

  const groupes = useMemo(() => {
    let result = filteredBordereaux;
    if (showVerifiedOnly) result = result.filter(item => item.isVerified === false);
    if (showSentOnly) result = result.filter(item => item.isSend === false);
    return grouperParPeriode(result);
  }, [filteredBordereaux, showVerifiedOnly, showSentOnly]);

  if (isLoading) {
    return <div className="text-center m-5 text-muted">Chargement...</div>;
  }

const supprimer = (liste: Listes) => {
  onDelete(liste, fetchLBordereau);
};

    const ChangerNumBl=(index:number,value:string)=>{
      handleNumBlChange(form,setForm,index,value);
    }
    const AddNumBl=()=>{
      handleAddNumBl(form,setForm);
    }
    const RemoveNumBl=(index:number)=>{
      handleRemoveNumBl(form,setForm,index);
    }


  return (
    <div className="container mt-4">
      <div className="col-12 col-md-6 m-auto mb-3">
        <input
          className="form-control"
          type="text"
          placeholder="Rechercher"
          value={search}
          onChange={searchData}
        />
      </div>

      <div className="col-12 col-md-6 d-flex flex-wrap gap-3 m-auto align-items-center">
        <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={openCreatePiece}>
          <PlusCircle /> Créer pièces
        </button>

        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="switch-verified"
            checked={showVerifiedOnly}
            onChange={() => setShowVerifiedOnly(prev => !prev)}
          />
          <label className="form-check-label" htmlFor="switch-verified">
            Non vérifiés
          </label>
        </div>

        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="switch-sent"
            checked={showSentOnly}
            onChange={() => setShowSentOnly(prev => !prev)}
          />
          <label className="form-check-label" htmlFor="switch-sent">
            Non livrés
          </label>
        </div>
      </div>

      {isModalOpen && (
        <ModalBordereauFormAdmin
          form={form}
          error={error}
          isEditMode={isEditMode}
          isAdminOrMagasinLoin={isAdminOrMagasinLoin} 
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          closeModal={closeModal}
          isModifier={isModifier}
          handleNumBlChange={ChangerNumBl} handleAddNumBl={AddNumBl} handleRemoveNumBl={RemoveNumBl}
        />
      )}

      {Object.entries(groupes).map(([periode, elements]) =>
        elements.length > 0 ? (
          <div key={periode} className="mb-5">
            <h4 className="text-primary mb-3">{periode}</h4>
            <div className="row g-4">
              {elements.map(b => (
                <div className="col-12 col-md-6 col-lg-3" key={b.id}>
                  <BordereauCard
                    b={b}
                    setForm={setForm}
                    setIsEditMode={setIsEditMode}
                    setIsModalOpen={setIsModalOpen}
                    setSelectedUser={setSelectedUser}
                    setError={setError}
                    onDelete={supprimer}
                    setIsModifier={setIsModifier}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};

export default Home;
